import { QueryClient } from "@tanstack/react-query";
const isDevServer = import.meta.env.MODE === "development";
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: isDevServer ? false : 1, // Retry up to 1 times if not on a dev server
      refetchOnWindowFocus: false,
    },
  },
});
